/**
 * Hardcoded staff allowlist for the super-admin dashboard.
 *
 * Must match `STAFF_USER_IDS` in `workers/leads/src/routes/admin.ts`
 * — the backend gate is the source of truth, but mirroring it here lets
 * us hide UI early so non-staff don't see broken admin links.
 */
export const STAFF_USER_IDS: ReadonlySet<string> = new Set([
  'user_3BdeFiHkxhqW88wlGwPykWzneyf', // knwn4official@gmail.com (KNWN4 Team)
  'user_3BME50OEjstIWRWux8UonVnxb8M', // tj@knwn4.com (TJ)
  'user_3BN11CgTrP2XlGNJ8ChfdMXxm1Q', // eli@knwn4.com (Eli)
  'user_3C4CzlgLjarwyXJkhGHHXMGA2SE', // taha.a.hashmi@gmail.com (Taha)
])

export function isStaffUser(userId: string | null | undefined): boolean {
  return Boolean(userId && STAFF_USER_IDS.has(userId))
}

/**
 * Narrower gate than `isStaffUser` — restricts to Taha only. Used for
 * internal-only debug affordances (Preview AI Messages, Test Mode) that
 * even Eli/TJ shouldn't see in the customer-facing campaign view during
 * the launch window.
 */
export const TAHA_USER_ID = 'user_3C4CzlgLjarwyXJkhGHHXMGA2SE'

export function isTahaOnly(userId: string | null | undefined): boolean {
  return userId === TAHA_USER_ID
}
